<app-menu-bar></app-menu-bar>

<div class="dashboard-page">
    <div class="dashboard-container">
        <app-dashboard-nav></app-dashboard-nav>

        <div id="messages">
            <div class="messages-head">
                <div class="text-area">
                    <span class="title">Messages</span>
                    <span class="subtitle">
                        @if (!loading) {
                            {{ openCount }} open · {{ resolvedCount }} resolved
                        }
                    </span>
                </div>
                <input class="search" type="text" placeholder="Search name, email, phone or text" autocomplete="off"
                    [(ngModel)]="search" />
            </div>

            <div class="filter-tabs" role="tablist">
                <button type="button" role="tab" [class.active]="filter === 'open'" [attr.aria-selected]="filter === 'open'"
                    (click)="setFilter('open')">Open ({{ openCount }})</button>
                <button type="button" role="tab" [class.active]="filter === 'resolved'" [attr.aria-selected]="filter === 'resolved'"
                    (click)="setFilter('resolved')">Resolved ({{ resolvedCount }})</button>
                <button type="button" role="tab" [class.active]="filter === 'all'" [attr.aria-selected]="filter === 'all'"
                    (click)="setFilter('all')">All ({{ messages.length }})</button>
            </div>

            @if (loading) {
                <div class="loading-state">
                    <span class="spinner" role="status" aria-label="Loading messages"></span>
                </div>
            } @else if (messages.length === 0) {
                <p class="state-text">No messages yet.</p>
            } @else if (filteredMessages.length === 0) {
                <p class="state-text">
                    @if (search.trim()) {
                        No messages match “{{ search }}”.
                    } @else if (filter === 'open') {
                        Nothing open — every message has been resolved.
                    } @else {
                        No resolved messages yet.
                    }
                </p>
            } @else {
                <div class="message-list">
                    @for (m of filteredMessages; track m.id) {
                        <article class="message-card" [class.is-resolved]="m.resolved">
                            <div class="card-head">
                                <div class="who">
                                    <span class="avatar">{{ initials(m) }}</span>
                                    <div class="who-text">
                                        <span class="name">{{ m.name || 'Name not provided' }}</span>
                                        <span class="sent-at">{{ m.createdAt | customDate }}</span>
                                    </div>
                                </div>
                                <!-- Sits with the name: who wrote in and how to reach
                                     them read as one unit. -->
                                <div class="contact-pills">
                                    <a class="contact-pill" [href]="'mailto:' + m.email">
                                        <i class="fa-solid fa-envelope" aria-hidden="true"></i>
                                        <span class="contact-value">{{ m.email }}</span>
                                    </a>
                                    <a class="contact-pill" [href]="'tel:' + m.phoneNumber">
                                        <i class="fa-solid fa-phone" aria-hidden="true"></i>
                                        <span class="contact-value">{{ m.phoneNumber }}</span>
                                    </a>
                                </div>

                                <span class="badge" [class.resolved]="m.resolved">
                                    {{ m.resolved ? 'Resolved' : 'Open' }}
                                </span>
                            </div>

                            <div class="message-block">
                                <span class="block-label">Message</span>
                                <p class="message-text">{{ m.message }}</p>
                            </div>

                            <div class="card-foot">
                                @if (m.resolved && m.resolvedByName) {
                                    <span class="resolved-by">Resolved by {{ m.resolvedByName }}</span>
                                }
                                <button type="button" class="resolve-btn" [class.reopen]="m.resolved"
                                    [disabled]="isSaving(m)" (click)="toggleResolved(m)">
                                    {{ m.resolved ? 'Reopen' : 'Mark resolved' }}
                                </button>
                            </div>
                        </article>
                    }
                </div>
            }
        </div>
    </div>
</div>

<app-footer></app-footer>
